import { toPascalCase } from '../../../utils/toPascalCase';
import { getOfflineIdFromStorage } from './userIdSettings';
import {
  EventParams,
  DataForEventParams,
  DataFromPatient,
  DefaultEventParams,
  WebPatientData,
  AppPatientData,
} from '../Event.types';

const offlineIdFromStorage = getOfflineIdFromStorage();

export const setDefaultEventParams = (
  dataForEventParams: DataForEventParams,
  eventParams: EventParams = {}
): EventParams => {
  const defaultParams = setEventParamsByAudience(dataForEventParams);

  const params = {
    ...defaultParams,
    ...eventParams,
  };

  return params;
};

const setEventParamsByAudience = ({
  user,
  userVariant,
  audience,
  path,
  custom,
}: DataForEventParams): DefaultEventParams => {
  if (userVariant === 'profissional') return { audience };

  const defaultParams = getDefaultParamsFromPatient({
    user,
    path,
    custom,
    audience,
  });

  return {
    audience,
    ...defaultParams,
  };
};

const getDefaultParamsFromPatient = ({
  user,
  path,
  custom,
  audience,
}: DataFromPatient): DefaultEventParams => {
  const offlineId = custom?.offlineId || offlineIdFromStorage;

  const user_id =
    custom?.user_id ||
    (audience === 'app'
      ? (user as AppPatientData)?.id
      : (user as WebPatientData)?.id);

  const patientId =
    custom?.patientId ||
    (audience === 'app'
      ? (user as AppPatientData)?.paciente?.id
      : (user as WebPatientData)?.patientId);

  const clinic_name =
    custom?.clinic_name ||
    (audience === 'app'
      ? (user as AppPatientData)?.clinica?.nome
      : (user as WebPatientData)?.clinic?.name);

  const clinic_id =
    custom?.clinic_id ||
    (audience === 'app'
      ? (user as AppPatientData)?.clinica?.id
      : (user as WebPatientData)?.clinic?.id);

  const routeName =
    toPascalCase(custom?.screen_name || path).replace(/\d/g, '') || 'Home';

  const params: DefaultEventParams = {
    offlineId,
    ...(patientId ? { user_id: patientId } : {}),
    ...(user_id ? { id: user_id } : {}),
    ...(clinic_id ? { clinic_id } : {}),
    ...(clinic_name ? { clinic_name } : {}),
    screen_name: routeName,
    screen_class: routeName,
  };

  return params;
};
